module.exports = __webpack_public_path__ + "static/2-382850d4dacce740ee9bd7b5898392c7.jpg";